import { render, staticRenderFns } from "./annCom.vue?vue&type=template&id=1c838936&scoped=true"
import script from "./annCom.vue?vue&type=script&lang=js"
export * from "./annCom.vue?vue&type=script&lang=js"
import style0 from "./annCom.vue?vue&type=style&index=0&id=1c838936&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c838936",
  null
  
)

export default component.exports